import { clampPct } from '../utils/hixrs';

export function CommentBubbleIcon() {
  return (
    <svg className="comment-bubble-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 4.25C7.6 4.25 4 7.35 4 11.18c0 3.84 3.6 6.94 8 6.94 1.05 0 2.08-.18 3.03-.54L20 19.25l-1.34-3.79A6.47 6.47 0 0 0 20 11.18c0-3.83-3.6-6.93-8-6.93Z" />
    </svg>
  );
}

export function EmptyState({ eyebrow = 'Empty', title, body, actionLabel, onAction, compact = false }) {
  return (
    <div className={`empty-state ${compact ? 'compact' : ''}`.trim()}>
      <div className="empty-state-mark">{eyebrow}</div>
      <div className="empty-state-title">{title}</div>
      {body && <div className="empty-state-body">{body}</div>}
      {actionLabel && onAction && (
        <button type="button" className="empty-state-action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export function SplitBar({ pctA, className = '' }) {
  const redPct = clampPct(pctA);
  const bluePct = 100 - redPct;

  return (
    <div className={`split-bar ${className}`.trim()} aria-hidden="true">
      <div className="split-bar-segment split-red" style={{ flexBasis: `${redPct}%` }} />
      <div className="split-bar-segment split-blue" style={{ flexBasis: `${bluePct}%` }} />
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-line short"></div>
      <div className="skeleton-line long"></div>
      <div className="skeleton-line medium"></div>
      <div className="skeleton-btns">
        <div className="skeleton-btn"></div>
        <div className="skeleton-btn"></div>
      </div>
    </div>
  );
}

export function SkeletonList({ count = 3 }) {
  return (
    <div className="skeleton-list">
      {Array.from({ length: count }).map((_, index) => <SkeletonCard key={index} />)}
    </div>
  );
}
